// extracted by extract-css-chunks-webpack-plugin
module.exports = {"Breadcrumb__li":"Breadcrumb__li","Breadcrumb__divider":"Breadcrumb__divider"};